import { useContext } from 'react'

import { type AllStepsData } from '../steps'
import { useSophisticatedTestStore } from '../useSophisticatedTestStore'
import { useUser } from '~/@biz_account/useUser/useUser'
import { SophisticatedFormStepContext } from './context'

export function useFormStepSophisticated() {
  const { user } = useUser()
  const { testData, updateTestData, goForward } = useSophisticatedTestStore(
    user?._id ?? null
  )
  const context = useContext(SophisticatedFormStepContext)

  if (!context) {
    throw new Error('FormStepContext.Provider is not initialized')
  }

  return {
    formData: testData ?? ({} as AllStepsData),
    onStepCompleted: (data: Parameters<typeof updateTestData>[0]) => {
      updateTestData(data)
      goForward()
    },
    onCompleted: (data: Parameters<typeof updateTestData>[0]) => {
      updateTestData(data)
      context.onCompleted(data)
    },
  }
}
